import React from 'react';
import { IEditorProps } from '../Editor';
import { IListItemProps } from 'components/lists/ListItem';
import { ArrayEditor } from '../ArrayEditor';
import { getMomentDateObject } from 'utils/DateTimeUtils';

interface IDateTimeArrayEditorProps extends IEditorProps {}

/**
 * Array editor with sort by date.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function DateTimeArrayEditor(props: IDateTimeArrayEditorProps) {
  return <ArrayEditor {...props} compareFunction={compareTimeTimeArrayEntries} />;
}

function compareTimeTimeArrayEntries(a: IListItemProps, b: IListItemProps): number {
  if (a.label === b.label) {
    // skip making moment objects when equal:
    return 0;
  }

  const dateA = getMomentDateObject(a.label);
  const dateB = getMomentDateObject(b.label);
  return dateA.isBefore(dateB) ? -1 : 1;
}
